import ApiService from '../apiservice'

export default class RouteService extends ApiService {
    constructor() {
        super('');
    }

    getRoutes() {
        return this.get('/routes');
    }

    getRouteInformationByVehicle(idRoute) {
        return this.get('/route', {"id": idRoute});
    }

    addRoute(data) {
        return this.post('/route/add', data, 1);
    }

    updateWayPoints(data) {
        return this.post('/route/waypoints', data, 1);
    }

    updateRelocateWayPoints(data) {
        return this.post('/route/relocateWaypoints', data, 1);
    }

    removeRoute(idRoute) {
        return this.get('/route/delete', {"id": idRoute});
    }

    getLinks() {
        return this.get('/route/plates');
    }
}